export const LOAD_LABEL_REVIEW_ITEM_DATA = 'labelReviewItemWizard/LOAD_LABEL_REVIEW_ITEM_DATA';
export const UPDATE_LABEL_REVIEW_ITEM_DATA = 'labelReviewItemWizard/UPDATE_LABEL_REVIEW_ITEM_DATA';
export const EDIT_COMMENT = 'labelReviewItemWizard/EDIT_COMMENT';
export const RESET_COMMENT = 'labelReviewItemWizard/RESET_COMMENT';
